export enum PaymentSource {
  Alipay = 'alipay',
  Giropay = 'giropay',
  Ideal = 'ideal',
  P24 = 'p24',
  Bancontact = 'bancontact',
  Blik = 'blik',
  Eps = 'eps',
  Payu = 'payu',
  Mybank = 'mybank',
  Trustly = 'trustly',
  Verkkopankki = 'verkkopankki',
  Wechatpay = 'wechatpay',
  Boleto = 'boletobancario',
  Oxxo = 'oxxo',
  Multibanco = 'multibanco',
  Satispay = 'satispay',
  Paidy = 'paidy'
}
